"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Checked;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Checked(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Arrows_",
    "data-name": "Arrows+"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "checked"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "compound",
    d: "M81.43,92.5H18.57A11.09,11.09,0,0,1,7.5,81.43V18.57A11.09,11.09,0,0,1,18.57,7.5H81.43A11.09,11.09,0,0,1,92.5,18.57V81.43A11.09,11.09,0,0,1,81.43,92.5Zm-62.86-80a6.07,6.07,0,0,0-6.07,6.07V81.43a6.07,6.07,0,0,0,6.07,6.07H81.43a6.07,6.07,0,0,0,6.07-6.07V18.57a6.07,6.07,0,0,0-6.07-6.07ZM42.1,63.56a3.16,3.16,0,0,1-2.24-.93L25.73,48.5A2.5,2.5,0,1,1,29.27,45L42.1,57.8,70.73,29.17a2.5,2.5,0,0,1,3.54,3.54L44.34,62.63A3.12,3.12,0,0,1,42.1,63.56ZM40.81,59.1Z"
  }))));
}